import { EDITOR_ORIGIN } from '~/constants/editor';

import { Hint } from './Hint';

class CommandChannelMentionHint implements Hint {
  name = 'commandChannelMention';

  origin = EDITOR_ORIGIN.COMMAND_CHANNEL_MENTION_COMPLETE;

  fromDistance = 1;

  regex = /^\/goto #([^# \t]*)$/;

  checkActive(text: string, cursor?: { line: number; ch: number }): boolean {
    return cursor.line === 0 && this.regex.test(text);
  }

  convertItemToText({ title, channelId }: { title: string; channelId: string }) {
    return `[#${title}](dooray://${channelId}/channels/${channelId} "channel") `;
  }

  getQuery(text: string): string {
    const result = this.regex.exec(text);
    return result ? result[1] : '';
  }
}

export default new CommandChannelMentionHint();
